var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTecnicas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9112 12.9697V31.2719C31.9112 33.8832 29.7944 36 27.1851 36H12.8909C10.2817 36 8.16479 33.8832 8.16479 31.2719V12.9697C8.16479 11.6944 8.67096 10.5369 9.49102 9.68745H9.48709C9.48709 9.68745 9.49103 9.68549 9.49887 9.67961C9.64405 9.52854 9.79901 9.38925 9.96381 9.26173C10.213 9.06358 10.4798 8.8929 10.7643 8.74772C11.8982 7.7766 13.3736 6.10704 13.3716 4H26.5965C26.7162 6.12274 28.3033 7.84134 29.4334 8.80854C29.6747 8.94194 29.9062 9.09104 30.122 9.26173C30.2731 9.3814 30.4183 9.51088 30.5536 9.65017C30.5674 9.65802 30.5732 9.66194 30.5732 9.66194H30.5673C31.4011 10.5134 31.9171 11.6807 31.9171 12.9677L31.9112 12.9697Z",
    fill: "white",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1702 6.63087C32.1702 8.08461 31.2717 9.26173 30.1632 9.26173H10.007C9.99134 9.26173 9.9756 9.26173 9.96187 9.26173C8.87303 9.23034 8 8.06696 8 6.63087C8 5.90498 8.22365 5.24775 8.5866 4.77101C8.9515 4.29428 9.45183 4 10.007 4H30.1632C31.2717 4 32.1702 5.17713 32.1702 6.63087Z",
    fill: "#F5FBFA",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5192 11.3864H25.6469C27.8599 11.3864 29.659 13.1835 29.659 15.3984V19.3751C29.659 21.5881 27.8619 23.3852 25.6489 23.3852H14.5212C12.3082 23.3852 10.5092 21.5881 10.5092 19.3732V15.3965C10.5092 13.1835 12.3062 11.3845 14.5212 11.3845L14.5192 11.3864Z",
    fill: "#F9839A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4475 26.4202H22.0351",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4475 29.5258H28.6231",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9963 32.5667H28.1719",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.309 16.6599V17.1599H20.809H23.1066V17.1619H23.6066C23.7307 17.1619 23.8325 17.2637 23.8325 17.3878C23.8325 17.5119 23.7307 17.6137 23.6066 17.6137H20.809H20.309V18.1137V20.9093C20.309 21.0345 20.2081 21.1352 20.0831 21.1352C19.9591 21.1352 19.8572 21.0334 19.8572 20.9093V18.1137V17.6137H19.3572H16.5616C16.4351 17.6137 16.3344 17.5116 16.3337 17.389C16.335 17.2594 16.4382 17.1599 16.5616 17.1599H19.3572H19.8572V16.6599V13.8643C19.8572 13.7402 19.9591 13.6384 20.0831 13.6384C20.2081 13.6384 20.309 13.7391 20.309 13.8643V16.6599Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTecnicas);
export default __webpack_public_path__ + "static/media/Ic_tecnicas.772bfe3d45ff768089a6ee9ad3774c6f.svg";
export { ForwardRef as ReactComponent };